import { gql } from 'graphql-request';

export const GET_FULL_ITEMS_QUERY = gql`
  query (
    $searchTerm: String!
    $first: Int = 10
    $after: String
    $businessUnitId: String
    $businessUnitGroupId: String
  ) {
    items(
      searchTerm: $searchTerm
      first: $first
      after: $after
      businessUnitId: $businessUnitId
      businessUnitGroupId: $businessUnitGroupId
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        name
        description
        salesUnitOfMeasurement
        images {
          url
          size
        }
        priceSpecifications(currentOnly: true, type: SALES) {
          value
          currencyId
          taxRuleId
          taxableGroupId
        }
        depositAndFeeRuleIds
        itemIdentifiers {
          value
          type
        }
        additionalProperties {
          id
          name
          code
          description
          dataType
          value
          isMandatory
        }
      }
    }
  }
`;
